module.exports = __webpack_public_path__ + "img/credential-pic.6eb2c690.png";